
import { mapState } from 'vuex' // 引入mapState
// import { messageHandling } from '~/config/backMessage'
import userHeader from '~/components/login/userHeader.vue' // 头部
import userCountry from '~/components/login/userCountry.vue' // 国家
import wikiGeet from '~/components/common/wikiGeet.vue' // 极验
import userVerificacode from '~/components/login/userVerificacode.vue' // 验证码
import userVoicevercode from '~/components/login/userVoicevercode.vue' // 语音验证码
import userThreparty from '~/components/login/userThreparty.vue' // 三方登录
import userGraphical from '~/components/login/userGraphical.vue' // 图形验证码
export default {
  components: {
    'user-header': userHeader, // 头部
    'user-country': userCountry,
    'wiki-geet': wikiGeet, // 极验
    'user-verificacode': userVerificacode, // 验证码
    'user-voicevercode': userVoicevercode, // 语音验证码
    'user-threparty': userThreparty, // 三方登录
    'user-graphical': userGraphical // 图形验证码
  },
  props: {
    phone: {
      // 手机号
      type: [Number, String],
      default: ''
    },
    verifCode: {
      // 验证码
      type: String,
      default: ''
    },
    requestId: {
      // 极验requestId
      type: String,
      default: ''
    }
  },
  data() {
    return {
      firstLoad: true, // 是否为首次加载该组件
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      switchingState: 1, // 1 为电子邮箱 2为创建密码 3为设置基本信息 4为身份选择 5为手机 6为验证码
      // 密码过于简单,重新输入
      simplePsword: false,
      // 电子邮箱
      emailNumber: false, // 电子邮箱漂浮状态
      clearButton: false, // 清空
      pasclearButton: false, // 重新输入密码清空
      phoneLoading: false, // loading
      // 创建密码
      passwordState: false, // 密码字样漂浮状态
      oneseyes: false, // 密码输入框type
      // 基本信息
      genderState: 2, // 性别 1为男 0位女
      nickName: false, // 昵称字样漂浮状态
      // 过于简单,重新输入
      resetSte: false, // 密码字样漂浮状态
      // 身份选择
      identity: [
        {
          img: 'https://resources1.interface003.com/web20/img/login/trader-female.png',
          name: this.$v('交易者'),
          type: 900
        },
        {
          img: 'https://resources1.interface003.com/web20/img/login/Image.png',
          name: this.$v('分析师'),
          type: 1200
        },
        {
          img: 'https://resources1.interface003.com/web20/img/login/Image2.png',
          name: this.$v('从业者'),
          type: 600
        },
        {
          img: 'https://resources1.interface003.com/web20/img/login/Image3.png',
          name: this.$v('IB'),
          type: 300
        },
        {
          img: 'https://resources1.interface003.com/web20/img/login/Image4.png',
          name: this.$v('交易商'),
          type: 100
        }
      ],
      identitySelected: '100', // 身份选中
      // 手机
      roTade: false, // 国家下拉框
      phoneSize: false, // 手机号字样漂浮
      showDrag: false, // 极验
      // 绑定数值
      registerInit: {
        emailamobiledis: '', // 验证码传值展示
        mailVal: this.$route.query.email == 'null' ? '' : this.$route.query.email, // 电子邮箱绑定
        isemailreg: null, // 邮箱是否注册
        setPassword: '', // 密码绑定
        errPassword: '', // 密码错误提示
        nickVal: '', // 昵称绑定
        nickError: '', // 昵称错误提示
        phone: '', // 手机号绑定
        smsCode: '', // 验证码
        formatError: '', // 手机号错误提示
        mailError: '', // 邮箱错误提示
        isregistered: null, // 该手机号是否注册
        email: '', // 该手机号是否绑定邮箱
        requestId: '', // 验证码发送后的requestId
        emailphone: null, // email为邮箱,phone为手机号
        tripartite: null, // 三方注册判断值, email 为邮箱验证码 phone 为手机验证码
        emailSms: '', // 三方使用 邮箱验证码
        phoneSms: '', // 三方使用  手机验证码
        // 重新输入密码
        resetpasswordTet: '', // 头部绑定
        resetSetpassword: '' // 密码绑定
      },
      // 验证码
      voiceState: true, // 是否展示语音验证
      countOrnot: true, // 是否展示倒计时
      isVercode: false, // 是否校验验证码
      fingerprint: this.$cookies.get('wiki-bfp'), // 浏览器指纹
      verificationCode: 1, // 1为获取手机验证码 2为获取语音验证码
      canIskip: false, // 是否出现跳过
      loading: false, // 接口返回再次调用 loading
      isnewuser: false // 是否为新用户
    }
  },
  computed: {
    ...mapState(['usergetCountry']), // 选中的国家
    title() {
      if (this.switchingState == 1) {
        return this.$route.query.type == 'register' ? this.$v('绑定') : this.$v('注册')
      } else if (this.switchingState == 2) {
        return this.$v('创建密码')
      } else if (this.switchingState == 3) {
        return this.$v('设置基本信息')
      } else if (this.switchingState == 4) {
        return this.$v('选择您的角色')
      } else if (this.switchingState == 5) {
        return this.$v('手机')
      } else {
        return this.$v('注册')
      }
    }
  },
  watch: {
    roTade(newV) {
      // 监听国家下拉框
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs.userCountry._scrollInit()
        this.$refs.userCountry.getHeight()
      })
    },
    'registerInit.mailVal'(val) {
      // 电子邮箱绑定
      if (val && this.switchingState == 1) {
        // var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (reg.test(val)) {
          // alert('邮箱格式正确')
          this.clearButton = true // 下一步为true
        } else {
          // alert('邮箱格式不正确')
          this.clearButton = false // 下一步为true
        }
        // this.clearButton = true // 下一步为true
      } else if (!val) {
        this.clearButton = false // 下一步为false
      }
    },
    'registerInit.setPassword'(val) {
      // 密码绑定
      if (val && this.switchingState == 2) {
        this.clearButton = true // 下一步为true
      } else if (!val) {
        this.clearButton = false // 下一步为false
        this.registerInit.errPassword = '' // 错误提示为空
      }
    },
    'registerInit.resetSetpassword'(val) {
      // 密码简单密码绑定
      if (val) {
        this.pasclearButton = true
      } else if (!val) {
        this.pasclearButton = false
        this.registerInit.errPassword = '' // 错误提示为空
      }
    },
    'registerInit.nickVal'(val) {
      // 昵称绑定
      if (val) {
        this.clearButton = true // 下一步为true
      } else if (!val) {
        this.clearButton = false // 下一步为false
      }
    },
    'registerInit.phone'(val) {
      // 手机号绑定
      if (val && this.switchingState == 5) {
        this.clearButton = true // 下一步为true
      } else if (!val) {
        this.clearButton = false // 下一步为false
        this.registerInit.formatError = '' // 错误提示为空
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.coutryClose, { passive: true })
    // this.$nextTick(() => {
    //   document.querySelector('.wiki-head').style.display = 'none'
    // })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    geetError() {
      // 极验错误
      this.showDrag = false // 极验框状态取消
      this.switchingState = 8 // 出现图形验证码
    },
    async setVercode(data) {
      // 图形验证成功后发送验证码
      // console.log('data: ', data)
      // console.log(this.registerInit.phone)
      const { phone } = this.registerInit // 手机号为空true/false
      if (!phone) return false
      // 校验手机号是否注册
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userCheckphone({ areaCode: this.usergetCountry.code, phoneNumber: this.signin.cellhoneNumber })
      this.registerInit.emailamobiledis = this.registerInit.phone // 展示为手机号
      if (this.registerInit.emailphone == 'register') this.registerInit.tripartite = 'phone'
      this.showDrag = false // 隐藏拖拽框
      // 发送验证码/语音验证码
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userVercode({
        areaCode: this.usergetCountry.code,
        phone: this.registerInit.phone,
        languageCode: this.LanguageCode,
        msgType: 0,
        smsBusinessType: 1,
        applicationType: 7,
        GeetestValidate: '',
        GeetestChallenge: '',
        graphCode: data
      })
      if (!succeed) return this.$message.error(extra) // 数据错误
      this.registerInit.requestId = result.requestid
      // this.$message({
      //   message: this.$v('验证码发送成功'),
      //   type: 'success'
      // })
      // 跳转验证码
      this.switchingState = 6
    },
    voiceTran() {
      // 语音获取验证码
      // this.switchingState = 5 // 修改为手机号弹框
      // this.countOrnot = true // 开启倒计时
      // this.getVercode() // 出现极验
      this.countOrnot = false // 展示 获取验证码
      this.switchingState = 6 // 修改为验证码弹框
      this.verificationCode = 2 // 修改为语音验证码获取
      // this.getVercode() // 出现极验
      this.$nextTick(() => {
        this.$refs.userverificacode.getweebgeet() // 调用极验
      })
    },
    voiceVerification() {
      // 语音获取验证码
      this.verificationCode = 2 // 修改为语音验证码获取
      this.switchingState = 7 // 修改为手机号弹框
    },
    voiceClose() {
      // 语音获取取消
      this.countOrnot = false // 取消倒计时
      this.switchingState = 6 // 跳转为验证码
    },
    getPhonecode(data = {}) {
      // 再次获取验证码
      // this.verificationCode = 1 // 切换为获取验证码
      this.countOrnot = true // 开启倒计时
      if (this.registerInit.emailphone == 'phone') {
        this.switchingState = 1 // 切换为邮箱验证码
        this.verifyMailbox() // 获取验证码
      } else if (this.registerInit.emailphone == 'email') {
        // this.switchingState = 5 // 切换为手机验证码
        // this.numberRis() // 获取手机验证码
        this.sendVCode(data) // 获取验证码
      } else if (this.registerInit.emailphone == 'register') {
        if (this.registerInit.tripartite == 'email') {
          this.switchingState = 1 // 切换为邮箱验证码
          this.verifyMailbox() // 获取验证码
        } else if (this.registerInit.tripartite == 'phone') {
          // this.switchingState = 5 // 切换为手机验证码
          // this.numberRis() // 获取手机验证码
          this.sendVCode(data) // 获取验证码
        }
      }
    },
    async getUsertion(code) {
      // 验证码成功之后登录
      this.registerInit.smsCode = code // 验证码赋值
      // 手机注册 邮箱发送验证码
      if (this.registerInit.emailphone == 'phone') {
        if (this.registerInit.isemailreg) {
          // 判断该邮箱是否注册
          const {
            succeed = false,
            extra = '',
            result = {}
          } = await this.$api.login.userBindphone({
            email: this.registerInit.mailVal, // 邮箱
            emailCode: this.registerInit.smsCode, // 验证码
            areaCode: this.usergetCountry.code, // 国家code
            phone: this.phone, // 手机号
            password: this.registerInit.setPassword, // 邮箱密码
            languagecode: this.LanguageCode,
            applicationtype: 7, // 版本
            platformtype: 0
          })
          if (!succeed) return this.$message.error(extra) // 数据错误
          this.accessCookie(result) // 加密cookie存cookie
        } else {
          console.log('邮箱未注册')
        }
      }
      // 三方注册 邮箱发送验证码 邮箱已注册流程
      if (this.registerInit.emailphone == 'register') {
        console.log(this.registerInit.tripartite)
        if (this.registerInit.tripartite == 'email') {
          this.registerInit.emailSms = code // 邮箱验证码赋值
          // 校验验证码是否正确
          const {
            succeed = false,
            extra = '',
            result = {}
          } = await this.$api.login.userVerifymail({
            Email: this.registerInit.mailVal,
            Code: code,
            ApplicationType: 7,
            CountryCode: this.usergetCountry.countryCode,
            LanguageCode: this.LanguageCode
          })
          if (!succeed) return this.$message.error(extra) // 数据错误
          this.registerInit.requestId = result.requestId
          // this.switchingState = 5 // 手机号展示
          this.thirdParty() // 三方换绑
        } else if (this.registerInit.tripartite == 'phone') {
          this.registerInit.phoneSms = code // 三方手机验证码赋值
          if (this.registerInit.isregistered) {
            // 判断该手机号是否注册、
            this.thirdParty() // 三方换绑
          } else {
            // 校验验证码是否正确
            const { succeed = false, extra = '' } = await this.$api.login.userVerifysms({
              AreaCode: this.usergetCountry.code,
              PhoneNumber: this.registerInit.phone,
              Smscode: code,
              ApplicationType: 7,
              ValidateSmsCodeType: 3,
              LanguageCode: this.LanguageCode
            })
            if (!succeed) return this.$message.error(extra) // 数据错误
            // console.log('验证码校验', result)
            this.switchingState = 3 // 跳转为性别选择
          }
        }
      }
      // 邮箱注册 手机发送验证码
      if (this.registerInit.emailphone == 'email') {
        if (this.registerInit.isregistered) {
          // 判断该手机号是否注册
          const {
            succeed = false,
            extra = '',
            result = {}
          } = await this.$api.login.userMobilechange({
            email: this.registerInit.mailVal, // 邮箱
            smsCode: this.registerInit.smsCode, // 验证码
            areaCode: this.usergetCountry.code, // 国家code
            phone: this.registerInit.phone, // 手机号
            password: this.registerInit.setPassword, // 邮箱密码
            languagecode: this.LanguageCode,
            applicationtype: 7, // 版本
            platformtype: 0
          })
          if (!succeed) return this.$message.error(extra) // 数据错误
          // console.log('result: ', result)
          this.accessCookie(result) // 加密cookie存cookie
        } else {
          // 校验验证码是否正确
          const { succeed = false, extra = '' } = await this.$api.login.userVerifysms({
            AreaCode: this.usergetCountry.code,
            PhoneNumber: this.registerInit.phone,
            Smscode: code,
            ApplicationType: 7,
            ValidateSmsCodeType: 3,
            LanguageCode: this.LanguageCode
          })
          if (!succeed) return this.$message.error(extra) // 数据错误
          // console.log('验证码校验', result)
          this.switchingState = 3 // 跳转为性别选择
        }
      }
    },
    async thirdParty() {
      // 三方换绑
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userChangebinding({
        openId: this.$route.query.id,
        accountNick: this.$route.query.name && this.$route.query.name != 'null' ? this.$route.query.name : '',
        accountHead: this.$route.query.img && this.$route.query.name != 'null' ? this.$route.query.img : '',
        accountType: this.$route.query.logintype,
        email: this.registerInit.mailVal,
        emailcode: this.registerInit.emailSms,
        smscode: this.registerInit.phoneSms,
        areacode: this.usergetCountry.code, // 国家code
        phone: this.registerInit.phone,
        password: this.registerInit.setPassword,
        languageCode: this.LanguageCode
      })
      if (!succeed) return this.$message.error(extra) // 数据错误
      this.accessCookie(result) // 加密cookie存cookie
    },
    coutryClose(e) {
      // 点击非组件区域关闭下拉框
      if (!this.$el.contains(e.target)) this.roTade = false
    },
    close() {
      // 清除按钮
      this.registerInit.phone = this.registerInit.formatError = '' // 手机输入内容为空/手机错误提示为空
      this.phoneSize = false // 请输入手机号样式为false
      this.phoneLoading = false // 加载动画为false
    },
    logoIn() {
      // 下一步|登录
      if (!this.clearButton && !this.registerInit.mailVal) return false
      if (this.switchingState == 1 && this.registerInit.mailVal != '') {
        this.phoneLoading = true
        // 1.5秒后loading关闭
        setTimeout(() => {
          this.phoneLoading = false
        }, 800)
        this.verifyMailbox() // 校验邮箱
        // this.switchingState = 2
        // this.clearButton = false
      } else if (this.switchingState == 2 && this.registerInit.setPassword != '') {
        if (this.registerInit.setPassword.length < 6 || this.registerInit.setPassword.length > 20) return (this.registerInit.errPassword = this.$v('密码为6-20位，不能包含汉字或空格'))
        this.registerInit.errPassword = ''
        if (this.phone) {
          // 如果为手机注册
          this.Samepassword() // 相同密码
        } else {
          this.switchingState = 5 // 跳转为手机获取验证码
          this.clearButton = false // 清空按钮样式
        }
      } else if (this.switchingState == 3 && (!this.registerInit.nickVal || this.genderState == 2)) {
        this.registerInit.nickError = this.$v('请设置基本信息')
      } else if (this.switchingState == 3 && this.registerInit.nickVal != '') {
        this.registerInit.nickError = ''
        // this.switchingState = 4
        this.isnewuser = true
        if (this.registerInit.emailphone == 'phone') {
          this.phoneRegister() // 手机注册
        } else if (this.registerInit.emailphone == 'email') {
          this.emailRegister() // 邮箱注册
        } else if (this.registerInit.emailphone == 'register') {
          this.tripartiteRegister() // 三方注册
        }
      } else if (this.switchingState == 5 && this.registerInit.phone != '') {
        this.phoneLoading = true
        // 1.5秒后loading关闭
        setTimeout(() => {
          this.phoneLoading = false
        }, 800)
        this.Samepassword() // 相同密码
      } else if (this.switchingState == 4 && !this.identitySelected) {
        this.registerInit.nickError = this.$v('请选择角色')
      } else if (this.switchingState == 4 && this.identitySelected) {
        // 身份选择
        // console.log('aaa', this.registerInit.emailphone)
        if (this.registerInit.emailphone == 'phone') {
          this.phoneRegister() // 手机注册
        } else if (this.registerInit.emailphone == 'email') {
          this.emailRegister() // 邮箱注册
        } else if (this.registerInit.emailphone == 'register') {
          this.tripartiteRegister() // 三方注册
        }
      }
    },
    async Samepassword() {
      // 如果重置密码输入则赋值到注册密码里
      if (this.registerInit.resetSetpassword) this.registerInit.setPassword = this.registerInit.resetSetpassword
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userSamepassword({
        phone: this.phone || this.registerInit.phone,
        passWord: this.registerInit.setPassword,
        languageCode: this.LanguageCode,
        areaCode: this.usergetCountry.code
      })
      if (!succeed && this.phone) {
        this.registerInit.errPassword = extra
        return
      } else if (!succeed) {
        this.registerInit.resetpasswordTet = extra
        this.simplePsword = true // 弹出重新输入密码
        return
      }
      if (this.phone) {
        this.simplePsword = false // 弹出重新输入密码
        this.switchingState = 3 // 跳转为设置基本信息
        this.clearButton = false // 清空按钮样式
      } else {
        console.log('result:获取相同密码 ', result)
        this.simplePsword = false // 弹出重新输入密码
        this.getVercode() // 获取验证码
      }
    },
    async emailRegister() {
      // 邮箱注册
      // 防止接口再次调用
      if (this.loading) {
        return false
      }
      this.loading = true
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userEmailregister(
        // 校验邮箱是否注册
        {
          areaCode: this.usergetCountry.code, // 国家code
          areaFlag: this.usergetCountry.flag, // 区旗
          phone: this.registerInit.phone, // 手机号
          lastname: this.registerInit.nickVal, // 昵称
          email: this.registerInit.mailVal, // 邮箱
          identityType: this.identitySelected, // 用户身份
          password: this.registerInit.setPassword,
          sex: this.genderState, // 性别
          isSkip: 0,
          requestId: this.registerInit.requestId,
          deviceInformation: 'web',
          version: 124,
          registrationPlatform: 0,
          deviceCode: this.fingerprint, // 指纹
          msgCode: this.registerInit.smsCode, // 验证码
          isContainIM: 1,
          userFirstName: this.registerInit.nickVal,
          registrationType: 311,
          applicationType: 7,
          countryCode: this.usergetCountry.countryCode,
          languageCode: this.LanguageCode,
          ip: this.$store.state.userIp // 用户ip
        }
      )
      // 调用接口,接口完成后，把loading值改为false
      this.loading = false
      if (!succeed) return this.$message.error(extra) // 数据错误
      // console.log('result: ', result)
      this.accessCookie(result) // 加密cookie存cookie
    },
    async phoneRegister() {
      // 手机注册
      // console.log(this.phone)
      // console.log(this.verifCode)
      // 防止接口再次调用
      if (this.loading) {
        return false
      }
      this.loading = true
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userEmailregister(
        // 手机注册
        {
          areaCode: this.usergetCountry.code, // 国家code
          areaFlag: this.usergetCountry.flag, // 区旗
          phone: this.phone, // 手机号
          lastname: this.registerInit.nickVal, // 昵称
          email: this.registerInit.mailVal, // 邮箱
          identityType: this.identitySelected, // 用户身份
          password: this.registerInit.setPassword,
          sex: this.genderState, // 性别
          isSkip: 0,
          requestId: this.requestId,
          deviceInformation: 'web',
          version: 124,
          registrationPlatform: 0,
          deviceCode: this.fingerprint, // 指纹
          msgCode: this.verifCode, // 验证码
          isContainIM: 1,
          userFirstName: this.registerInit.nickVal,
          registrationType: 311,
          applicationType: 7,
          countryCode: this.usergetCountry.countryCode,
          languageCode: this.LanguageCode,
          ip: this.$store.state.userIp // 用户ip
        }
      )
      // 调用接口,接口完成后，把loading值改为false
      this.loading = false
      if (!succeed) return this.$message.error(extra) // 数据错误
      // console.log('result: ', result)

      this.accessCookie(result) // 加密cookie存cookie
    },
    async tripartiteRegister() {
      // 三方注册
      // 防止接口再次调用
      if (this.loading) {
        return false
      }
      this.loading = true
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userThirdregistration(
        // 手机注册
        {
          openId: this.$route.query.id,
          unionId: this.$route.query.id,
          accountNick: this.$route.query.name && this.$route.query.name != 'null' ? this.$route.query.name : '',
          accountHead: this.$route.query.img && this.$route.query.img != 'null' ? this.$route.query.img : '',
          isReplace: true,
          accountType: this.$route.query.logintype,
          registrationPlatform: 0,
          languageCode: this.LanguageCode,
          areaCode: this.usergetCountry.code,
          areaFlag: this.usergetCountry.flag,
          phone: this.registerInit.phone,
          lastname: this.registerInit.nickVal,
          email: this.registerInit.mailVal,
          identityType: this.identitySelected,
          password: this.registerInit.setPassword,
          sex: this.genderState,
          isSkip: 0,
          requestId: this.registerInit.requestId,
          deviceInformation: 'web',
          version: 124,
          deviceCode: this.fingerprint,
          inviteCode: '',
          msgCode: this.registerInit.phoneSms,
          isContainIM: 0,
          userFirstName: this.registerInit.nickVal,
          friendsharecontent: '',
          registrationType: 311,
          applicationType: 7,
          countryCode: this.usergetCountry.countryCode,
          ip: this.$store.state.userIp
        }
      )
      // 调用接口,接口完成后，把loading值改为false
      this.loading = false
      if (!succeed) return this.$message.error(extra) // 数据错误
      this.accessCookie(result) // 加密cookie存cookie
    },
    async verifyMailbox() {
      // 校验邮箱
      console.log('校验邮箱')
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userMailregis(
        // 校验邮箱是否注册
        {
          email: this.registerInit.mailVal,
          languageCode: this.LanguageCode
        }
      )
      if (!succeed) return (this.registerInit.mailError = extra) // 数据错误
      this.registerInit.isemailreg = result // 邮箱是否注册
      this.isRegistration(result) // 判断是否为邮箱注册
    },
    async isRegistration(result) {
      // 邮箱注册 手机注册切换逻辑
      // console.log('result:邮箱是否注册 ', result)
      if (result) {
        // 邮箱已注册
        if (this.phone || this.$route.query.type == 'register') {
          // 判断是否是登录注册
          this.registerInit.emailphone = this.$route.query.type == 'register' ? 'register' : 'phone' // 为手机号注册
          if (this.registerInit.emailphone == 'register') this.registerInit.tripartite = 'email' // 三方注册为邮箱验证码
          this.switchingState = 6 // 跳转为验证码弹框
          this.voiceState = false // 语音验证码不展示
          this.registerInit.emailamobiledis = this.registerInit.mailVal // 展示为邮箱
          const res = await this.$api.login.userMailcode(
            // 发送邮件验证码
            {
              email: this.registerInit.mailVal,
              languageCode: this.LanguageCode,
              emailType: 0,
              applicationType: 7, // 项目类型
              version: 124 // 版本
            }
          )
          if (!res.succeed) return console.log(res.extra) // 数据错误
          // console.log(res)
        } else {
          this.registerInit.emailphone = 'email' // 为邮箱注册
          this.registerInit.mailError = this.$v('邮箱已被注册')
        }
      } else {
        // 邮箱未注册
        if (this.phone) {
          // 判断是否是登录注册
          this.registerInit.emailphone = 'phone' // 为手机号注册
        } else if (this.$route.query.type == 'register') {
          this.registerInit.emailphone = 'register' // 为手机号注册
          // this.registerInit.tripartite
        } else {
          this.registerInit.emailphone = 'email'
        }
        this.registerInit.mailError = '' // 错误提示取消
        // console.log('this.registerInit.emailphone: ', this.registerInit.emailphone)

        // this.$message.error('未注册')
        this.switchingState = 2 // 跳到输入密码
        this.clearButton = false // 取消按钮样式
      }
    },
    getVercode() {
      // 获取验证码
      if (this.usergetCountry.code == '0086') {
        // 如果为国内则走国内手机号验证
        if (!this.registerInit.phone) {
          return (this.registerInit.formatError = this.$v('用户手机号有误'))
        }
        const myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (myreg.test(this.registerInit.phone)) {
          console.log('验证手机号成功')
          this.registerInit.formatError = '' // 验证成功则错误消息清空
          this.numberRis() // 手机号校验
        } else {
          console.log('手机号验证失败')
          this.registerInit.formatError = this.$v('手机号格式错误')
        }
      } else {
        // 否则走国外手机号验证
        if (!this.registerInit.phone) {
          return (this.registerInit.formatError = this.$v('用户手机号有误'))
        }
        const myreg = /^.{5,20}$/
        if (myreg.test(this.registerInit.phone)) {
          console.log('国外手机号验证成功')
          this.registerInit.formatError = '' // 验证成功则错误消息清空
          this.numberRis() // 手机号校验
        } else {
          this.registerInit.formatError = this.$v('手机号格式错误')
        }
      }
    },
    async numberRis() {
      // 手机校验是否注册之后是否发送验证码国内国际逻辑
      console.log('进入手机校验')
      const { phone = '' } = this.registerInit // 手机号为空true/false
      if (!phone) return false
      // 校验手机号是否注册
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userCheckphone({
        areaCode: this.usergetCountry.code,
        phoneNumber: phone
      })
      if (!succeed) return this.$message.error(extra) // 数据错误
      this.registerInit.isregistered = result.isregister // 该手机号是否注册
      this.registerInit.email = result.email // 该手机号是否绑定邮箱
      this.voiceState = true
      console.log('手机号是否注册result: ', result)
      if (result.isregister) {
        // 手机注册过则出现极验
        this.showDrag = true // 极验框展示
      } else if (this.usergetCountry.code == '0086') {
        // 手机未注册,为86,则出现极验
        this.canIskip = true // 未注册且为0086则出现跳过
        this.showDrag = true // 极验框展示
      } else {
        // 不为86则直接跳注册流程
        this.switchingState = 3 // 跳转为性别选择
        // this.$emit('loginSwitch', 2) // 切换注册流程
      }
    },
    async sendVCode(data = {}) {
      // 验证码登录极验
      console.log('data: ', data)
      const { phone = '' } = this.registerInit // 为空true/false
      if (!phone) return false
      this.showDrag = false // 隐藏拖拽框
      this.registerInit.emailamobiledis = this.registerInit.phone // 展示为手机号
      if (this.registerInit.emailphone == 'register') this.registerInit.tripartite = 'phone'
      // 发送验证码/语音验证码
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userVercode({
        areaCode: this.usergetCountry.code,
        phone,
        languageCode: this.LanguageCode,
        msgType: this.verificationCode == 1 ? 0 : 1,
        smsBusinessType: 1,
        applicationType: 7,
        GeetestValidate: data.geetest_validate,
        GeetestChallenge: data.geetest_challenge
      })
      console.log('result: ', result)
      if (!succeed) return this.$message.error(extra) // 数据错误
      this.registerInit.requestId = result.requestid
      this.verificationCode = 1
      // this.$message.success('极验成功')
      // 跳转验证码
      this.switchingState = 6
    },
    async accessCookie(userInfo) {
      // 加密cookie存cookie
      console.log('userInfo2: ', userInfo)
      // 防止接口再次调用
      if (this.loading) {
        return false
      }
      this.loading = true
      this.$store.commit('setUser', {
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick,
        avatar: userInfo.showAvataraddress || userInfo.avatar
      })
      if (userInfo?.LoginToken?.expires_in) {
        const ntoken = `${userInfo?.LoginToken?.token_type} ${userInfo?.LoginToken?.access_token}`
        this.$cookies.set('logintoken', ntoken, {
          domain: this.$store.state.cookieHost,
          maxAge: userInfo?.LoginToken?.expires_in,
          path: '/'
        }) // 存储token
        this.$cookies.set('quitetoken', `${userInfo?.LoginToken?.access_token},${userInfo?.LoginToken?.refresh_token}`, {
          // 获取退出时所需要的access_token-refresh_token
          domain: this.$store.state.cookieHost,
          maxAge: userInfo?.LoginToken?.expires_in,
          path: '/'
        }) // 存储token
        this.$cookies.set('refreshtime', String(new Date().getTime()), {
          // 刷新时间
          domain: this.$store.state.cookieHost,
          maxAge: userInfo?.LoginToken?.expires_in,
          path: '/'
        }) // 存储token
      }
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userEncryption({
        userId: userInfo.userId,
        nick: userInfo.showNickName || userInfo.nick,
        avatar: userInfo.showAvataraddress || userInfo.avatar
      })
      if (!succeed) return this.$message.error(extra) // 数据错误
      if (this.$store.state.host.includes('wikifx')) {
        this.CookieSet('DJkdikKMG', result.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else if (this.$store.state.host.includes('fxeye')) {
        this.CookieSet('ViLartidlakd', result.Value, `.${this.$store.state.host.split('.')[1]}.${this.getSuffix(this.$store.state)}`)
      } else {
        this.$cookies.set('WsdsfgDGdagYms', result.Value)
        // this.CookieSet(
        //   'WsdsfgDGdagYms',
        //   result.Value,
        //   `.${this.comurl}.${this.$store.state.my_domin}`
        // )
        const postdata = {
          op_type: 'setCookie',
          url: '',
          parm: result.Value
        }
        // console.log(123);
        window.parent.postMessage(postdata, '*')
      }
      // 调用接口,接口完成后，把loading值改为false
      this.loading = false
      // this.$message.success('登录成功')
      // 如果为login.html页面则跳转
      // if (this.$store.state.path == 'login.html') {
      //   setTimeout(() => {
      //   }, 200)
      // } else {
      this.$store.commit('setUsercookie', result?.Value)
      const postdata = {
        op_type: 'reload',
        url: '',
        parm: result?.Value
      }
      window.parent && window.parent.postMessage(postdata, '*')
      if (this.isnewuser) this.$emit('popjoinflow')
      else {
        this.$emit('close')
        if (this.$store.state.path.includes('login.html')) {
          setTimeout(() => {
            if (process.client) location.href = `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/usercenter/index.html`
          }, 200)
        }
      }

      // }
      // if (this.registerInit.emailphone == 'register') {
      //   if (process.client) location.href = this.$route.query.returnurl
      // }
    },
    CookieSet(key, val, dom) {
      // 存cookie
      const expiresTime = new Date(Date.now() + 8.64e7 * 999)
      this.$cookies.set(key, val, {
        expires: expiresTime,
        path: '/',
        domain: dom
      })
    }
  }
}
